import React from "react";
import { getVehicleTitle } from "../../../../shared-logic/utils/uscUtils";
import { useUscSelector } from "../../../redux/store";
import { useUscLabel } from "../../../utils/labels";
import { UscContext } from "../../../../shared-logic/types/UscCommonTypes";
import { UscNavStepEnum } from "../../../utils/constants";
import { getUscInternalLink } from "../../../utils/navUtils";
import useNavParams from "../../../hooks/useNavParams";
import Icon from "../../../../shared-components/lexus/styles/atoms/Icon";
import * as Styles from "./Breadcrumbs.styles";
import { uscStepTrackingLocationMap } from "../../../utils/tracking";
import { useCommonLabel } from "../../../../../common-deprecated/utils/commonLabels";

const Breadcrumbs = (): JSX.Element | null => {
    const result = useUscSelector((state) => state.vehicle.result);
    const uscEnv = useUscSelector((state) => state.vehicle.type);
    const step = useUscSelector((state) => state.nav.step);
    const [breadcrumbsUsedLabel, breadcrumbsStockLabel, breadcrumbsExtrasLabel, breadcrumbsTitle] = useUscLabel([
        "uscBreadcrumbsUsed",
        "uscBreadcrumbsStock",
        "uscBreadcrumbsExtras",
        "uscA11yBreadcrumbsTitle",
    ]);
    const landmarkLabel = useCommonLabel("ariaBreadcrumbs");
    const navParams = useNavParams(uscStepTrackingLocationMap[step]);
    const pdpLink = getUscInternalLink(navParams, UscNavStepEnum.Pdp);
    const extrasLink = getUscInternalLink(navParams, UscNavStepEnum.Extras);

    const { carFilterUrl } = navParams;

    if (!result) return null;

    const breadcrumbsLabel = uscEnv === UscContext.Used ? breadcrumbsUsedLabel : breadcrumbsStockLabel;
    const vehicleTitle = getVehicleTitle(result.product);

    return (
        <Styles.Wrapper aria-label={landmarkLabel} darkBackground={step === UscNavStepEnum.Extras}>
            <Styles.Title>{breadcrumbsTitle}:</Styles.Title>
            <Styles.List role="list" itemScope itemType="https://schema.org/BreadcrumbList">
                <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                    <Styles.Link href={carFilterUrl} itemProp="item">
                        <span itemProp="name">{breadcrumbsLabel}</span>
                    </Styles.Link>
                    <Styles.Separator>
                        <Icon variant="chevron-right" />
                    </Styles.Separator>
                    <meta itemProp="position" content="1" />
                </li>
                <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                    <Styles.Link
                        href={pdpLink.href}
                        onClick={pdpLink.onClick}
                        itemProp="item"
                        aria-current={step === UscNavStepEnum.Pdp && "location"}
                    >
                        <span itemProp="name">{vehicleTitle}</span>
                    </Styles.Link>
                    {step === UscNavStepEnum.Extras && (
                        <Styles.Separator>
                            <Icon variant="chevron-right" />
                        </Styles.Separator>
                    )}
                    <meta itemProp="position" content="2" />
                </li>
                {step === UscNavStepEnum.Extras && (
                    <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                        <Styles.Link
                            href={extrasLink.href}
                            onClick={extrasLink.onClick}
                            itemProp="item"
                            aria-current={step === UscNavStepEnum.Extras && "location"}
                        >
                            <span itemProp="name">{breadcrumbsExtrasLabel}</span>
                        </Styles.Link>
                        <meta itemProp="position" content="3" />
                    </li>
                )}
            </Styles.List>
        </Styles.Wrapper>
    );
};

export default Breadcrumbs;
